<!-- ----------------------------------------------- -->
<template>
  <div>
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 180 300"
      width="180"
      height="300"
    >
      <defs>
        <path d="M25 5L50 5L50 30L25 30L25 25Z" id="radarLevel8"></path>
        <path d="M25 35L50 35L50 60L25 60L25 55Z" id="radarLevel7"></path>
        <path d="M25 65L50 65L50 90L25 90L25 85Z" id="radarLevel6"></path>
        <path d="M25 95L50 95L50 120L25 120L25 115Z" id="radarLevel5"></path>
        <path d="M25 125L50 125L50 150L25 150L25 145Z" id="radarLevel4"></path>
        <path d="M25 155L50 155L50 180L25 180L25 175Z" id="radarLevel3"></path>
        <path d="M25 185L50 185L50 210L25 210L25 205Z" id="radarLevel2"></path>
        <path d="M25 215L50 215L50 240L25 240L25 235Z" id="radarLevel1"></path>
        <path d="M25 245L50 245L50 270L25 270L25 265Z" id="radarMissing"></path>
        <text id="radarUnitText" x="120" y="20" font-size="0.9rem">
          {{ text.radarUnit }}
        </text>
        <text id="radarLevel7Text" x="60" y="38" font-size="0.9rem">
          {{ text.radarLevel7 }}
        </text>
        <text id="radarLevel6Text" x="60" y="68" font-size="0.9rem">
          {{ text.radarLevel6 }}
        </text>
        <text id="radarLevel5Text" x="60" y="98" font-size="0.9rem">
          {{ text.radarLevel5 }}
        </text>
        <text id="radarLevel4Text" x="60" y="128" font-size="0.9rem">
          {{ text.radarLevel4 }}
        </text>
        <text id="radarLevel3Text" x="60" y="158" font-size="0.9rem">
          {{ text.radarLevel3 }}
        </text>
        <text id="radarLevel2Text" x="60" y="188" font-size="0.9rem">
          {{ text.radarLevel2 }}
        </text>
        <text id="radarLevel1Text" x="60" y="218" font-size="0.9rem">
          {{ text.radarLevel1 }}
        </text>
        <text id="radarMissingText" x="60" y="264" font-size="0.9rem">
          {{ text.radarMissing }}
        </text>
      </defs>
      <g>
        <use
          xlink:href="#radarUnitText"
          opacity="1"
          fill="#000000"
          fill-opacity="1"
        ></use>
        <g>
          <use
            xlink:href="#radarLevel8"
            opacity="1"
            :fill="color.radarLevel8"
            :fill-opacity="opacity"
            stroke="#000000"
            stroke-width="3"
            stroke-opacity="1"
          ></use>
        </g>
        <g>
          <use
            xlink:href="#radarLevel7"
            opacity="1"
            :fill="color.radarLevel7"
            :fill-opacity="opacity"
            stroke="#000000"
            stroke-width="3"
            stroke-opacity="1"
          ></use>
          <use
            xlink:href="#radarLevel7Text"
            opacity="1"
            fill="#000000"
            fill-opacity="1"
          ></use>
        </g>
        <g>
          <use
            xlink:href="#radarLevel6"
            opacity="1"
            :fill="color.radarLevel6"
            :fill-opacity="opacity"
            stroke="#000000"
            stroke-width="3"
            stroke-opacity="1"
          ></use>
          <use
            xlink:href="#radarLevel6Text"
            opacity="1"
            fill="#000000"
            fill-opacity="1"
          ></use>
        </g>
        <g>
          <use
            xlink:href="#radarLevel5"
            opacity="1"
            :fill="color.radarLevel5"
            :fill-opacity="opacity"
            stroke="#000000"
            stroke-width="3"
            stroke-opacity="1"
          ></use>
          <use
            xlink:href="#radarLevel5Text"
            opacity="1"
            fill="#000000"
            fill-opacity="1"
          ></use>
        </g>
        <g>
          <use
            xlink:href="#radarLevel4"
            opacity="1"
            :fill="color.radarLevel4"
            :fill-opacity="opacity"
            stroke="#000000"
            stroke-width="3"
            stroke-opacity="1"
          ></use>
          <use
            xlink:href="#radarLevel4Text"
            opacity="1"
            fill="#000000"
            fill-opacity="1"
          ></use>
        </g>
        <g>
          <use
            xlink:href="#radarLevel3"
            opacity="1"
            :fill="color.radarLevel3"
            :fill-opacity="opacity"
            stroke="#000000"
            stroke-width="3"
            stroke-opacity="1"
          ></use>
          <use
            xlink:href="#radarLevel3Text"
            opacity="1"
            fill="#000000"
            fill-opacity="1"
          ></use>
        </g>
        <g>
          <use
            xlink:href="#radarLevel2"
            opacity="1"
            :fill="color.radarLevel2"
            :fill-opacity="opacity"
            stroke="#000000"
            stroke-width="3"
            stroke-opacity="1"
          ></use>
          <use
            xlink:href="#radarLevel2Text"
            opacity="1"
            fill="#000000"
            fill-opacity="1"
          ></use>
        </g>
        <g>
          <use
            xlink:href="#radarLevel1"
            opacity="1"
            :fill="color.radarLevel1"
            :fill-opacity="opacity"
            stroke="#000000"
            stroke-width="3"
            stroke-opacity="1"
          ></use>
          <use
            xlink:href="#radarLevel1Text"
            opacity="1"
            fill="#000000"
            fill-opacity="1"
          ></use>
        </g>
        <g>
          <use
            xlink:href="#radarMissing"
            opacity="1"
            :fill="color.radarMissing"
            :fill-opacity="opacity"
            stroke="#000000"
            stroke-width="3"
            stroke-opacity="1"
          ></use>
          <use
            xlink:href="#radarMissingText"
            opacity="1"
            fill="#000000"
            fill-opacity="1"
          ></use>
        </g>
      </g>
    </svg>
  </div>
</template>
<!-- ----------------------------------------------- -->
<script>
import Color from "../../../scss/color.scss";

/**
 * 川の防災情報 地図画面 地図凡例ダイアログ レーダ雨量
 * LegendTmStgobs.vue
 * @author LIS
 */
export default {
  name: "legend-radar",
  data() {
    return {
      /** 色 */
      color: {
        radarLevel1: Color.radarLevel1,
        radarLevel2: Color.radarLevel2,
        radarLevel3: Color.radarLevel3,
        radarLevel4: Color.radarLevel4,
        radarLevel5: Color.radarLevel5,
        radarLevel6: Color.radarLevel6,
        radarLevel7: Color.radarLevel7,
        radarLevel8: Color.radarLevel8,
        radarMissing: Color.radarMissing,
      },
      /** 文字列リソース */
      text: {
        radarLevel7: "80",
        radarLevel6: "50",
        radarLevel5: "30",
        radarLevel4: "20",
        radarLevel3: "10",
        radarLevel2: "5",
        radarLevel1: "1",
        radarMissing: "欠測",
        radarUnit: "[mm/h]",
      },
    };
  },
  computed: {
    /** 透過設定 */
    opacity: {
      get() {
        // 不透明度に反転して、パーセント指定を少数に変換して返す
        return (100 - this.$store.state.radar.radarOpacity) * 0.01;
      },
    },
  },
};
</script>
